import { RootState } from "../../../../../redux/store";

export const error = (state: RootState) => state.customerAttachments.error;
export const getErrorAction = (state: RootState) => state.customerAttachments.errorAction;
export const filters = (state: RootState) => state.customerAttachments.filters;
export const selectedFile = (state:RootState) => state.customerAttachments.selectedFile;
export const selectedFileLoading = (state:RootState) => state.customerAttachments.selectedFileLoading;
export const fileDownloading = (state:RootState) => state.customerAttachments.fileDownloading;